// matchThemAllAnimation.js
var MatchThemAllAnimation = pc.createScript('matchThemAllAnimation');

MatchThemAllAnimation.attributes.add("matchThemAllButton", {type: "entity"});
MatchThemAllAnimation.attributes.add("continueButton", {type: "entity"});
MatchThemAllAnimation.attributes.add("homeButton", {type: "entity"});
MatchThemAllAnimation.attributes.add('Shine',{type: 'entity'});

var matchTimeBtnShown;
var matchTimeBtnTween;
var matchTimeBtnShineTween;
// initialize code called once per entity
MatchThemAllAnimation.prototype.initialize = function() {

    MatchThemAllAnimation.instance = this;
    this.entity.enabled = false;

    this.matchThemAllButton.button.on('click', function (event) {

        matchThemAllButtonClick = true;
        matchTimeBtnTween.stop();
        matchTimeBtnShineTween.stop();
        this.entity.enabled = false;

        if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "WantToMatchThemAllButton:Click", 1);}
        //ADSManager.instance.OpenRewardVideo(adsEnum.MatchThemAll);

        //GAADSManager.instance.showRewarded(adsType.MatchThemAllExtraTime);
        rewardedType = adsType.MatchThemAllExtraTime;
        if (gdsdk !== 'undefined' && gdsdk.preloadAd !== 'undefined') {
            gdsdk.showAd('rewarded');
        }

    }, this);

    this.continueButton.button.on('click', function (event) { 
        
        if (gdsdk !== 'undefined' && gdsdk.preloadAd !== 'undefined') {
            gdsdk.preloadAd();
        }

        matchTimeBtnTween.stop();
        matchTimeBtnShineTween.stop();
        this.entity.enabled = false;

        Timer.instance.levelEnding();
    }, this);

        matchTimeBtnTween=this.matchThemAllButton.tween(this.matchThemAllButton.getLocalScale()).to(new pc.Vec3(1, 1, 1), 0.8, pc.QuadraticInOut).yoyo(true).loop(true);
        matchTimeBtnShineTween=this.Shine.tween(this.Shine.getLocalPosition()).to({ x: 521.019, y: -13.637, z: 0 }, 1.5, pc.Linear).on('complete', function () { StartTimerAnimation.instance.Shine.setLocalPosition(new pc.Vec3(-271.456, -13.637, 0)); }).loop(true);
};

// update code called every frame
MatchThemAllAnimation.prototype.startAnimation = function () {

    if (PlayerManager.instance.levelData.levelName != "Donut Shop") {

       
        GameManager.instance.PauseGame();
        matchThemAllButton = false;
        this.homeButton.enabled = false;

        this.entity.enabled = true;

        matchTimeBtnTween.start();
        matchTimeBtnShineTween.start();
    }
};

// swap method called for script hot-reloading
// inherit your script state here
// MatchThemAllAnimation.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

